import { Box, styled, Typography } from '@mui/material';
import { JobApplication } from 'features/myJobs/types';
import { useTranslation } from 'react-i18next';

interface SectionNoteProps {
    job: JobApplication;
}

export default function SectionNote({ job }: SectionNoteProps) {
    const { t } = useTranslation('myJobs');

    if (!job.acceptedWithComment) {
        return null;
    }

    return (
        <>
            <Typography fontWeight="medium">
                { t('details.comment') }
            </Typography>
            <NoteBox>
                { job.acceptedWithComment }
            </NoteBox>
        </>
    );
}

const NoteBox = styled(Box)(({ theme }) => ({
    backgroundColor: '#f5f6f7',
    border: `1px solid ${ theme.palette.divider }`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0)
}));
